function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PaymentInstrumentTypeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors.deprecated';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import pathOr from 'ramda/src/pathOr';
import { DECIMAL_NUMBERS } from 'invision-core/src/constants/validation.constants';
import { hasAccess, getUpperLimitAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { unregisterUnsavedChanges } from 'invision-core/src/components/unsavedChangesPrompt/actions';
import clone from 'ramda/src/clone';
import CustomerCareKeys from '../../../../../locales/keys';
import { ApplyCreditErrorSelector, IsApplyingCreditSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { NEW_PAYMENT_INSTRUMENT, ORIGINAL_PAYMENT, REFUND_BY_CHECK } from '../../../../customer/applyCreditModal/apply.credit.modal.constants';
import { ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT, ISSUE_CREDIT_TO_ALTERNATE_PAYMENT_INSTRUMENT } from '../../../../../security.attributes';
import { isPaymentSelectable } from '../../../../customer/ewallet/ewallet.helpers';
import { CanChangePaymentInstrument, CurrentPaymentInstrumentsTypeSelector, MutablePaymentInstrumentsTypeFilterOptionsSelector, ApplyCreditFromOverviewPaymentOptionsSelector } from '../../../../../reducers/selectors/apply.credit.modal.selectors';
import { IsEligibleForPartialRefundsSelector } from '../../../../../reducers/selectors/customer.transactions.selectors';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { createPaymentInstrument, redeemGiftCard, retrieveWallet } from '../../../../../reducers/actions/customer.ewallet.actions';
import { applyOrderCredit } from '../../../../../reducers/actions/order.actions';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../../../../customer/ewallet/ewallet.constants';
import { NOTIFICATION_TIME_LENGTH } from '../../../../../customercare.constants';
import { EwalletErrorSelector, IsRetrievingEwalletDataSelector } from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../../../shared/contextualComponents/address/address.validator.helper';
import { setForceShowEditFormAddress, validateAddress } from '../../../../../reducers/actions/address.component.actions';
var ApplyCreditRefundModalComponent = /*#__PURE__*/function () {
  function ApplyCreditRefundModalComponent($filter, $ngRedux, uiNotificationService) {
    _classCallCheck(this, ApplyCreditRefundModalComponent);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      AMOUNT_TYPE: {
        MAX: 'max',
        CUSTOM: 'custom'
      },
      availableCards: [],
      creditLocaleKeys: CustomerCareKeys.ORDER_DETAILS.CREDIT,
      CustomerCareKeys: CustomerCareKeys,
      extraErrors: [],
      isEditingPaymentInstrument: false,
      model: {
        Amount: null,
        AmountType: 'max',
        Currency: null,
        CustomAmount: '',
        Description: null,
        SendNotification: false,
        ReasonCode: null
      },
      MAX_DESCR_LENGTH: 100,
      NEW_PAYMENT_INSTRUMENT: NEW_PAYMENT_INSTRUMENT,
      REFUND_BY_CHECK: REFUND_BY_CHECK,
      onSubmitForm: this.onSubmitForm.bind(this),
      ORIGINAL_PAYMENT: ORIGINAL_PAYMENT,
      paymentInstrumentRequestObject: {},
      regex: DECIMAL_NUMBERS,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ApplyCreditRefundModalComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          applyCreditError: ApplyCreditErrorSelector(store),
          canChangePaymentInstrument: CanChangePaymentInstrument(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPaymentInstrumentTypes: CurrentPaymentInstrumentsTypeSelector(store),
          eWalletError: EwalletErrorSelector(store),
          isApplyingCredit: IsApplyingCreditSelector(store),
          isDbss: IsDbss(store),
          isEligibleForPartialRefunds: IsEligibleForPartialRefundsSelector(store),
          isFetchingWallet: IsRetrievingEwalletDataSelector(store),
          paymentInstrumentsTypeFilterOptions: MutablePaymentInstrumentsTypeFilterOptionsSelector(store),
          paymentInstrumentTypeLoaded: PaymentInstrumentTypeLoadedSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store),
          unvalidatedAddresses: UnvalidatedAddressesSelector(store),
          validatedAddresses: ValidatedAddressesSelector(store),
          walletPaymentInstrumentsTypeFilterOptions: ApplyCreditFromOverviewPaymentOptionsSelector(store)
        };
      };
      var controllerActions = {
        applyOrderCredit: applyOrderCredit,
        createPaymentInstrument: createPaymentInstrument,
        fetchCodeTypes: fetchCodeTypes,
        redeemGiftCard: redeemGiftCard,
        retrieveWallet: retrieveWallet,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        unregisterUnsavedChanges: unregisterUnsavedChanges,
        validateAddress: validateAddress
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.canChangePaymentInstrument) {
        this.actions.retrieveWallet({
          customerId: this.state.currentCustomerId
        }).then(function () {
          _this.updateAvailablePaymentInstruments();
        });
      }
      this.model.Currency = this.currencyCode;
      this.dashboardAmount = this.amountToCredit;
      this.amountToCredit = this.amountToCredit > 0 ? this.amountToCredit : 0;
      this.model.Amount = this.amountToCredit;
      this.model.CustomAmount = this.amountToCredit;
      this.updateAvailablePaymentInstruments();
      if (!this.state.paymentInstrumentTypeLoaded) {
        this.actions.fetchCodeTypes(CODES.PaymentInstrumentType);
      }
      this.invalidAmountErrorMessage = !this.state.isEligibleForPartialRefunds ? this.creditLocaleKeys.AMOUNT_VALUE_INVALID_DBSS : this.creditLocaleKeys.AMOUNT_VALUE_INVALID;
      this.actions.fetchCodeTypes(CODES.FeatureToggleConfig);
    }
  }, {
    key: "canChangePaymentInstrument",
    get: function get() {
      return hasAccess(this.state.userSecurityAttributes, ISSUE_CREDIT_TO_ALTERNATE_PAYMENT_INSTRUMENT);
    }
  }, {
    key: "isOriginalPaymentOnly",
    get: function get() {
      return this.selectedCard.value === this.ORIGINAL_PAYMENT && this.availableCards.length === 1 && this.availableCards[0].value === this.ORIGINAL_PAYMENT;
    }
  }, {
    key: "updateAvailablePaymentInstruments",
    value: function updateAvailablePaymentInstruments() {
      if (this.state && (this.state.canChangePaymentInstrument || this.isDashboard)) {
        this.availableCards = clone(this.isDashboard ? this.state.walletPaymentInstrumentsTypeFilterOptions : this.state.paymentInstrumentsTypeFilterOptions);
      } else {
        this.availableCards = [];
      }
      if (!this.isDashboard) {
        this.availableCards.unshift({
          value: this.ORIGINAL_PAYMENT,
          text: i18n.translate(this.creditLocaleKeys.ORIGINAL_PAYMENT_METHOD)
        });
      }
      this.selectedCard = this.availableCards[0];
      this.allowPaymentSelection = true;
      this.updateAllowablePaymentSelection();
    }
  }, {
    key: "updateAllowablePaymentSelection",
    value: function updateAllowablePaymentSelection() {
      var _this2 = this;
      this.paymentInstruments.forEach(function (paymentInstrument) {
        var shouldAllow = isPaymentSelectable(paymentInstrument);
        if (!shouldAllow) {
          _this2.allowPaymentSelection = false;
        }
      });
    }
  }, {
    key: "applyOrderCredit",
    value: function applyOrderCredit(customerId, details) {
      var _this3 = this;
      this.actions.applyOrderCredit(customerId, details).then(function () {
        _this3.actions.unregisterUnsavedChanges('paymentBillingAddressForm.paymentInstrumentForm');
        _this3.onSubmit()();
      });
    }
  }, {
    key: "isAmountValid",
    get: function get() {
      var value = parseFloat(this.model.Amount);
      return value > 0 && (!this.state.isEligibleForPartialRefunds ? true : value <= this.maxCreditAmount);
    }
  }, {
    key: "customValidations",
    value: function customValidations() {
      this.extraErrors = this.isAmountValid ? [] : [i18n.translate(this.invalidAmountErrorMessage, {
        minAmount: this.$filter('invCurrency')(0, this.currencyCode),
        maxAmount: this.$filter('invCurrency')(this.maxCreditAmount, this.currencyCode)
      })];
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      var _this4 = this;
      this.customValidations();
      this.ApplyCreditRefundForm.$submitted = true;
      if (this.ApplyCreditRefundForm.$valid && this.isAmountValid) {
        this.validateAddressWithAPI().then(function () {
          var addressKey = _this4.getAddressKey();
          var validatedAddress = _this4.state.validatedAddresses[addressKey];
          var _this4$model = _this4.model,
            Amount = _this4$model.Amount,
            Currency = _this4$model.Currency,
            Description = _this4$model.Description,
            ReasonCode = _this4$model.ReasonCode,
            SendNotification = _this4$model.SendNotification;
          var creditDetails = Object.assign({
            Amount: Amount,
            Currency: Currency,
            Description: Description,
            ReasonCode: ReasonCode,
            SendNotification: SendNotification
          }, _this4.additionalApiData);
          if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
            if (_this4.allowPaymentSelection) {
              if (_this4.selectedCard.value === _this4.NEW_PAYMENT_INSTRUMENT) {
                if (_this4.paymentInstrumentRequestObject.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD) {
                  _this4.actions.redeemGiftCard(_this4.paymentInstrumentRequestObject.Pin, _this4.paymentInstrumentRequestObject.CustomerId).then(function (redeemedGiftCard) {
                    _this4.uiNotificationService.success(i18n.translate(CustomerCareKeys.E_WALLET.REDEEM_GIFT_CARD_SUCCESS), null, {
                      timeOut: NOTIFICATION_TIME_LENGTH
                    });
                    creditDetails.PaymentInstrument = {
                      Id: redeemedGiftCard.Id
                    };
                    if (_this4.state.isDbss && _this4.isBalanceAdjustment) {
                      _this4.updateModelForReasonCode(creditDetails);
                    }
                    _this4.applyOrderCredit(_this4.state.currentCustomerId, creditDetails);
                  });
                } else {
                  _this4.actions.createPaymentInstrument(_this4.paymentInstrumentRequestObject).then(function (createdPaymentInstrument) {
                    _this4.uiNotificationService.success(i18n.translate(CustomerCareKeys.MAKE_PAYMENT.CREATE_INSTRUMENT_SUCCESS), null, {
                      timeOut: NOTIFICATION_TIME_LENGTH
                    });
                    creditDetails.PaymentInstrument = {
                      Id: createdPaymentInstrument.PaymentInstrument.Id
                    };
                    if (_this4.state.isDbss && _this4.isBalanceAdjustment) {
                      _this4.updateModelForReasonCode(creditDetails);
                    }
                    _this4.applyOrderCredit(_this4.state.currentCustomerId, creditDetails);
                  });
                }
              } else if (_this4.selectedCard.value !== _this4.REFUND_BY_CHECK && _this4.selectedCard.value !== _this4.ORIGINAL_PAYMENT) {
                creditDetails.PaymentInstrument = {
                  Id: _this4.selectedCard.value
                };
              }
            }
            if (_this4.state.isDbss && _this4.isDashboard && _this4.selectedCard.value === _this4.REFUND_BY_CHECK) {
              creditDetails.RefundByCheck = true;
              if (_this4.isBalanceAdjustment) {
                _this4.updateModelForReasonCode(creditDetails);
              }
              _this4.applyOrderCredit(_this4.state.currentCustomerId, creditDetails);
            }
            if (creditDetails.PaymentInstrument && creditDetails.PaymentInstrument.Id || _this4.selectedCard.value === _this4.ORIGINAL_PAYMENT) {
              if (_this4.state.isDbss && _this4.isBalanceAdjustment) {
                _this4.updateModelForReasonCode(creditDetails);
              }
              _this4.applyOrderCredit(_this4.state.currentCustomerId, creditDetails);
            }
          } else {
            _this4.actions.setForceShowEditFormAddress(false);
            _this4.uiNotificationService.transientError(i18n.translate(CustomerCareKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
          }
        }).catch(function (err) {
          _this4.uiNotificationService.transientError(err.translatedMessage);
        });
      }
    }
  }, {
    key: "updateModelForReasonCode",
    value: function updateModelForReasonCode(creditDetails) {
      delete creditDetails.ReasonCode;
      creditDetails.BalanceAdjustmentReasonCode = this.model.ReasonCode;
      return creditDetails;
    }
  }, {
    key: "handleSetAmountType",
    value: function handleSetAmountType() {
      if (this.model.AmountType === this.AMOUNT_TYPE.MAX) {
        this.model.CustomAmount = undefined;
        this.model.Amount = this.maxCreditAmount;
      } else if (this.model.AmountType === this.AMOUNT_TYPE.CUSTOM) {
        this.model.Amount = this.model.CustomAmount || 0;
        this.ApplyCreditRefundForm.applyCreditAmount.$setUntouched();
      }
      this.customValidations();
    }
  }, {
    key: "maxCreditAmount",
    get: function get() {
      return Math.min(this.amountToCredit, getUpperLimitAccess(this.state.userSecurityAttributes, ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT.id));
    }
  }, {
    key: "updateCustomAmount",
    value: function updateCustomAmount() {
      if (this.model.AmountType === this.AMOUNT_TYPE.CUSTOM) {
        this.model.Amount = this.model.CustomAmount;
      }
      this.customValidations();
    }
  }, {
    key: "updateCreditAmount",
    value: function updateCreditAmount() {
      this.model.AmountType = this.AMOUNT_TYPE.CUSTOM;
      this.model.Amount = this.model.CustomAmount;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }

    //check if this works
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['ApplyCreditRefundForm', 'paymentBillingAddressForm.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['ApplyCreditRefundForm', 'paymentBillingAddressForm.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      //TO-DO verify the appropriate address type below
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true
        };
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }]);
}();
export default {
  bindings: {
    additionalApiData: '<?',
    amountToCredit: '<',
    brandableCurrencyName: '<?',
    creditReasons: '<',
    currencyCode: '<',
    isDashboard: '<?',
    isBalanceAdjustment: '<?',
    onClose: '&',
    onSubmit: '&',
    paymentInstruments: '<',
    title: '@'
  },
  template: require('./apply.credit.refund.modal.html'),
  controller: ApplyCreditRefundModalComponent,
  controllerAs: 'ApplyCreditRefund'
};